(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(89028);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94742:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 6716:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "home-page": __webpack_require__(71110),
    "section-try-for-free": __webpack_require__(33686)
};


/***/ }),

/***/ 43378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(6716),
    de: __webpack_require__(94742)
};


/***/ }),

/***/ 89028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/HomepageHero/index.js
var HomepageHero = __webpack_require__(27473);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/HomeNewAndNoteworthy/index.js
var HomeNewAndNoteworthy = __webpack_require__(75590);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/HomeResources/index.js
var HomeResources = __webpack_require__(50758);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/WistiaVideo/index.js
var WistiaVideo = __webpack_require__(52198);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/WistiaVideo/Embed.js
var Embed = __webpack_require__(94394);
// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Tabs/index.js + 1 modules
var Tabs = __webpack_require__(77739);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/molecules/BlockQuote/index.js + 4 modules
var BlockQuote = __webpack_require__(27276);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/SmartTabs/index.js
var SmartTabs = __webpack_require__(53381);
;// CONCATENATED MODULE: ./src/HomePage/Tabs.js








function HomePageTabs(param) {
    let { active  } = param;
    const [t] = (0,i18/* useLocale */.bU)("home-page");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* default.Head */.ZP.Head, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmartTabs/* default */.Z, {
                initialActiveTab: active,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.TabBody.Mounted */.Z.TabBody.Mounted, {
                        className: "width-100",
                        id: "1",
                        Component: atomic_react_Grid/* Col */.JX,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* BlockQuoteItem */.q0, {
                            active: true,
                            author: t("BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_1"),
                            institution: t("BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_1"),
                            children: t("BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_1")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.TabBody.Mounted */.Z.TabBody.Mounted, {
                        id: "2",
                        className: "width-100",
                        Component: atomic_react_Grid/* Col */.JX,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* BlockQuoteItem */.q0, {
                            active: true,
                            author: t("BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_2"),
                            institution: t("BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_2"),
                            children: t("BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_2")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.TabBody.Mounted */.Z.TabBody.Mounted, {
                        id: "3",
                        className: "width-100",
                        Component: atomic_react_Grid/* Col */.JX,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* BlockQuoteItem */.q0, {
                            active: true,
                            author: t("BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_3"),
                            institution: t("BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_3"),
                            children: t("BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_3")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.TabBody.Mounted */.Z.TabBody.Mounted, {
                        id: "4",
                        className: "width-100",
                        Component: atomic_react_Grid/* Col */.JX,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* BlockQuoteItem */.q0, {
                            active: true,
                            author: t("BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_4"),
                            institution: t("BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_4"),
                            children: t("BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_4")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.TabBody.Mounted */.Z.TabBody.Mounted, {
                        id: "5",
                        className: "width-100",
                        Component: atomic_react_Grid/* Col */.JX,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuote/* BlockQuoteItem */.q0, {
                            active: true,
                            author: t("BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_5"),
                            institution: t("BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_5"),
                            children: t("BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_5")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.Tab */.Z.Tab, {
                                className: "mr-6",
                                id: "1",
                                href: "#",
                                cell: "medium-4",
                                src: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_1"),
                                alt: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_1_ALT"),
                                Component: BlockQuote/* BlockQuoteThumb */._w
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.Tab */.Z.Tab, {
                                className: "mr-6",
                                id: "2",
                                href: "#",
                                cell: "medium-4",
                                src: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_2"),
                                alt: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_2_ALT"),
                                Component: BlockQuote/* BlockQuoteThumb */._w
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.Tab */.Z.Tab, {
                                className: "mr-6",
                                id: "3",
                                href: "#",
                                cell: "medium-4",
                                src: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_3"),
                                alt: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_3_ALT"),
                                Component: BlockQuote/* BlockQuoteThumb */._w
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.Tab */.Z.Tab, {
                                className: "mr-6",
                                id: "4",
                                href: "#",
                                cell: "medium-4",
                                src: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_4"),
                                alt: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_4_ALT"),
                                Component: BlockQuote/* BlockQuoteThumb */._w
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartTabs/* default.Tab */.Z.Tab, {
                                id: "5",
                                href: "#",
                                cell: "medium-4",
                                src: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_5"),
                                alt: t("BLOCK_QUOTE_SECOND_BLOCK_IMAGE_5_ALT"),
                                Component: BlockQuote/* BlockQuoteThumb */._w
                            })
                        ]
                    })
                ]
            })
        })
    });
}
HomePageTabs.propTypes = {
    active: prop_types.string.isRequired
};
/* harmony default export */ var HomePage_Tabs = (HomePageTabs);

// EXTERNAL MODULE: ./locales/home-page/index.js
var home_page = __webpack_require__(43378);
var home_page_default = /*#__PURE__*/__webpack_require__.n(home_page);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 3 modules
var SiteLayout = __webpack_require__(40398);
;// CONCATENATED MODULE: ./pages/index.js
















const Homepage = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("home-page");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        isBorderBottomNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("PAGE_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("PAGE_TITLE"),
                        description: t("META_DESCRIPTION"),
                        locale: t("META_LOCALE"),
                        type: t("META_TYPE"),
                        url: t("META_URL"),
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        siteName: t("META_SITE_NAME"),
                        articlePublisher: t("META_ARTICLE_PUBLISHER"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        title: t("PAGE_TITLE"),
                        description: t("META_DESCRIPTION"),
                        site: t("META_TWITTER_SITE"),
                        card: t("META_TWITTER_CARD"),
                        image: t("META_TWITTER_IMAGE"),
                        creator: t("META_TWITTER_CREATOR"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: t("META_CANONICAL")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Author */.ZP.Author, {
                        content: t("META_AUTHOR")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageHero/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageHero/* default.Head */.ZP.Head, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* default.Head.Title */.ZP.Head.Title, {
                                children: t("TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* default.Head.Description */.ZP.Head.Description, {
                                children: t("PAGE_DESCRIPTION")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageHero/* default.Head.Buttons */.ZP.Head.Buttons, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: HomepageHero/* HomepageHeroButtonDefault */.wk,
                                        href: t("TRY_SNAPGENE"),
                                        children: t("TRY_FOR_FRY_BTN")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: HomepageHero/* HomepageHeroButtonSecondary */.dz,
                                        href: t("PRICING"),
                                        children: t("PRICING_BTN")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageHero/* default.Head.Links */.ZP.Head.Links, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* HomepageHeroHeadLink */.IP, {
                                        href: "#home-news-release-notes",
                                        children: t("NEW_IN_SNAPGENE_LINK")
                                    }),
                                    " ",
                                    "|",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* HomepageHeroHeadLink */.IP, {
                                        href: "/features",
                                        children: t("CORONOVIRUS_RESOURCES_LINK")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                                md: 12,
                                spacing: {
                                    mt: 10,
                                    mb: 20
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WistiaVideo/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Embed/* default */.Z, {
                                        id: "0ud4wih90g"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageHero/* default.Body */.ZP.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* default.Body.Item */.ZP.Body.Item, {
                                numItem: 1,
                                title: t("DESIGN_BETTER_PROCEDURES_TITLE"),
                                description: t("DESIGN_BETTER_PROCEDURES_DESC"),
                                srcImg: t("DESIGN_BETTER_PROCEDURES_IMAGE"),
                                href: t("DESIGN_BETTER_PROCEDURES_HREF"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* HomepageHeroBodyItemLink */.Z, {
                                    href: t("DESIGN_BETTER_PROCEDURES_HREF"),
                                    children: t("LEARN_MORE")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* default.Body.Item */.ZP.Body.Item, {
                                numItem: 2,
                                title: t("VISUALIZE_YOUR_PROCESS_TITLE"),
                                description: t("VISUALIZE_YOUR_PROCESS_DESC"),
                                srcImg: t("VISUALIZE_YOUR_PROCESS_IMAGE"),
                                href: t("VISUALIZE_YOUR_PROCESS_HREF"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* HomepageHeroBodyItemLink */.Z, {
                                    href: t("VISUALIZE_YOUR_PROCESS_HREF"),
                                    children: t("LEARN_MORE")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* default.Body.Item */.ZP.Body.Item, {
                                numItem: 3,
                                title: t("RECORD_YOUR_WORK_TITLE"),
                                description: t("RECORD_YOUR_WORK_DESC"),
                                srcImg: t("RECORD_YOUR_WORK_IMAGE"),
                                href: t("RECORD_YOUR_WORK_HREF"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageHero/* HomepageHeroBodyItemLink */.Z, {
                                    href: t("RECORD_YOUR_WORK_HREF"),
                                    children: t("LEARN_MORE")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeNewAndNoteworthy/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNewAndNoteworthy/* default.Title */.Z.Title, {
                        children: t("NEW_AND_NOTEWORTHY_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeNewAndNoteworthy/* default.List */.Z.List, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNewAndNoteworthy/* default.List.Item */.Z.List.Item, {
                                id: "home-news-academy",
                                title: t("EXPLORE_SNAPGENE_ACADEMY_TITLE"),
                                srcImg: t("EXPLORE_SNAPGENE_ACADEMY_IMAGE"),
                                href: t("EXPLORE_SNAPGENE_ACADEMY_HREF"),
                                children: t("EXPLORE_SNAPGENE_ACADEMY_DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNewAndNoteworthy/* default.List.Item */.Z.List.Item, {
                                id: "home-news-release-notes",
                                title: t("NEW_IN_SNAPGENE_TITLE"),
                                srcImg: t("NEW_IN_SNAPGENE_IMAGE"),
                                href: t("NEW_IN_SNAPGENE_HREF"),
                                children: t("NEW_IN_SNAPGENE_DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNewAndNoteworthy/* default.List.Item */.Z.List.Item, {
                                id: "home-news-coronavirus-resources",
                                title: t("CORONAVIRUS_RESOURCES_TITLE"),
                                srcImg: t("CORONAVIRUS_RESOURCES_IMAGE"),
                                href: t("CORONAVIRUS_RESOURCES_HREF"),
                                children: t("CORONAVIRUS_RESOURCES_DESC")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeResources/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeResources/* default.Head */.Z.Head, {
                        title: t("RESOURCES_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeResources/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeResources/* default.Body.Item */.Z.Body.Item, {
                                title: t("PLASMID_FILES_TITLE"),
                                srcImg: t("PLASMID_FILES_IMAGE"),
                                href: t("PLASMID_FILES_HREF"),
                                children: t("PLASMID_FILES_DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeResources/* default.Body.Item */.Z.Body.Item, {
                                title: t("TUTORIAL_VIDEOS_TITLE"),
                                srcImg: t("TUTORIAL_VIDEOS_IMAGE"),
                                href: t("TUTORIAL_VIDEOS_HREF"),
                                children: t("TUTORIAL_VIDEOS_DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeResources/* default.Body.Item */.Z.Body.Item, {
                                title: t("USER_GUIDE_TITLE"),
                                srcImg: t("USER_GUIDE_IMAGE"),
                                href: t("USER_GUIDE_HREF"),
                                children: t("USER_GUIDE_DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeResources/* default.Body.Item */.Z.Body.Item, {
                                title: t("SNAPGENE_VIEWER_TITLE"),
                                srcImg: t("SNAPGENE_VIEWER_IMAGE"),
                                href: t("SNAPGENE_VIEWER_HREF"),
                                children: t("SNAPGENE_VIEWER_DESC")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_Tabs, {
                active: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var pages = ((0,pipe/* default */.Z)(Homepage, (0,i18/* WithLocale */._t)({
    resources: (home_page_default())
})));


/***/ }),

/***/ 98106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19334);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);
/* harmony import */ var _insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18774);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46003);






const SectionTryForFree = ()=>{
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)("section-try-for-free");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Title */ .Z.Title, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    Tag: "span",
                    children: t("TRY_FREE_TEXT")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionTryForFree__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Action */ .Z.Action, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Link */ .Z.Link, {
                    href: "/free-trial",
                    size: "s",
                    className: "ml-auto mr-auto",
                    children: t("TRY_FREE_BUTTON_TEXT")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTryForFree);


/***/ }),

/***/ 71110:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"SnapGene | Software for everyday molecular biology","META_DESCRIPTION":"SnapGene offers the fastest and easiest way to plan, visualize, and document DNA cloning and PCR. You can easily annotate features and design primers.","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"website","META_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_IMAGE_SECURE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_TWITTER_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_URL":"https://www.snapgene.com","META_CANONICAL":"https://www.snapgene.com/","PAGE_TITLE":"SnapGene | Software for everyday molecular biology","TITLE":"The Future of Cloning is Smarter and Faster","PAGE_DESCRIPTION":"Improve your core molecular biology procedures, and improve your results","HERO_HEAD_IMAGE":"/images/snapgene/homepage/homepage-new-hero.png","TRY_SNAPGENE":"/free-trial","TRY_FOR_FRY_BTN":"Try for Free","PRICING":"/pricing","PRICING_BTN":"Pricing","NEW_IN_SNAPGENE_LINK":"What’s New in SnapGene 7.1","CORONOVIRUS_RESOURCES_LINK":"All Features","DESIGN_BETTER_PROCEDURES_TITLE":"Design Better Procedures","DESIGN_BETTER_PROCEDURES_DESC":"Accurately design and simulate cloning procedures. Test complicated projects, catch errors before they happen, and obtain the right constructs the first time.","DESIGN_BETTER_PROCEDURES_IMAGE":"/images/snapgene/homepage/homepage-hero-1.png","DESIGN_BETTER_PROCEDURES_HREF":"/features#beyond-the-basics-of-molecular-cloning","LEARN_MORE":"Learn More","VISUALIZE_YOUR_PROCESS_TITLE":"Visualize Your Process","VISUALIZE_YOUR_PROCESS_DESC":"Cloning is easier when you can see what you are doing. The intuitive interface offers you unparalleled visibility into your work, simplifying often complex tasks.","VISUALIZE_YOUR_PROCESS_IMAGE":"/images/snapgene/homepage/homepage-hero-2.png","VISUALIZE_YOUR_PROCESS_HREF":"/features","RECORD_YOUR_WORK_TITLE":"Automatically Record Your Work","RECORD_YOUR_WORK_DESC":"SnapGene automates documentation, so you don’t have to. See and share every sequence edit and cloning procedure that led to your final plasmid.","RECORD_YOUR_WORK_IMAGE":"/images/snapgene/homepage/homepage-hero-3.png","RECORD_YOUR_WORK_HREF":"/features#configured-for-automatic-documentation-and-easy-data-exchange","NEW_AND_NOTEWORTHY_TITLE":"New and Noteworthy","EXPLORE_SNAPGENE_ACADEMY_TITLE":"Explore SnapGene Academy","EXPLORE_SNAPGENE_ACADEMY_DESC":"Master SnapGene and key concepts in cloning with our new online learning center, SnapGene Academy. Containing over 50 video tutorials taught by scientific experts, SnapGene Academy helps you advance your skills across multiple molecular biology courses.","EXPLORE_SNAPGENE_ACADEMY_IMAGE":"/images/snapgene/marketing/snapgene-academy-logo.png","EXPLORE_SNAPGENE_ACADEMY_HREF":"/resources","NEW_IN_SNAPGENE_TITLE":"Discover What’s New in SnapGene 7.1.","NEW_IN_SNAPGENE_DESC":"SnapGene 7.1 provides enhancements to streamline file search within a selected folder, introduces secondary structure visualizations for ssDNA sequences including primers, and includes a variety of fixes to improve stability, file import workflows and other functions.","NEW_IN_SNAPGENE_IMAGE":"/images/snapgene/homepage/homepage-homepage-new-3.png","NEW_IN_SNAPGENE_HREF":"/updates","CORONAVIRUS_RESOURCES_TITLE":"Coronavirus Resources","CORONAVIRUS_RESOURCES_DESC":"Download genomes of common coronaviruses including SARS, MERS and COVID-19, as well as primers and probes for the SARS-CoV-2 genome.","CORONAVIRUS_RESOURCES_IMAGE":"/images/snapgene/homepage/homepage-homepage-new-2.png","CORONAVIRUS_RESOURCES_HREF":"/plasmids/coronavirus_resources","RESOURCES_TITLE":"Resources","PLASMID_FILES_TITLE":"Plasmid Files","PLASMID_FILES_DESC":"Download over 2,700 annotated plasmid files, including commonly used cloning vectors from all major suppliers.","PLASMID_FILES_IMAGE":"/images/snapgene/homepage/homepage-plasmid-files.svg","PLASMID_FILES_HREF":"/plasmids","TUTORIAL_VIDEOS_TITLE":"Tutorial Videos","TUTORIAL_VIDEOS_DESC":"Learn how to visualize and search DNA sequences, create rich maps, annotate features and primers, and simulate cloning.","TUTORIAL_VIDEOS_IMAGE":"/images/snapgene/homepage/homepage-video.svg","TUTORIAL_VIDEOS_HREF":"/resources","USER_GUIDE_TITLE":"User Guide","USER_GUIDE_DESC":"Comprehensive knowledge base with step by step guides showing you how to perform key tasks in SnapGene.","USER_GUIDE_IMAGE":"/images/snapgene/homepage/homepage-user-guide.svg","USER_GUIDE_HREF":"https://support.snapgene.com/hc/en-us/categories/10304176221716","SNAPGENE_VIEWER_TITLE":"SnapGene Viewer","SNAPGENE_VIEWER_DESC":"SnapGene Viewer lets you see your data for free with the same rich visualization, annotation, and sharing capabilities as the fully enabled SnapGene software.","SNAPGENE_VIEWER_IMAGE":"/images/snapgene/homepage/homepage-viewer.svg","SNAPGENE_VIEWER_HREF":"/snapgene-viewer","BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_1":"A. Matouschek","BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_1":"Northwestern University","BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_1":"SnapGene is so easy to use that my lab adopted it instantly. It saves a lot of time and money as we now do all our cloning in SnapGene first and catch any snags in the strategy before they hold us up.","BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_2":"Richard","BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_2":"Gurdon Institute, University of Cambridge","BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_2":"SnapGene is AMAZING. Designing cloning strategies is incredibly easy and so quick! The In-Fusion simulations have literally saved me days worth of time. The maps look fantastic. I am completely sold!","BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_3":"D. Strongin","BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_3":"Fred Hutchinson Cancer Center","BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_3":"SnapGene is awesome. It is straightforward enough to start using right away, yet rich with sophisticated features that cover all of my cloning needs. I recommend this software to anyone who clones DNA.","BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_4":"W. Rossoll","BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_4":"Emory University","BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_4":"SnapGene is a most excellent and very intuitive software, and I keep discovering additional useful features. I have tried MANY software packages, none of them even comes close to SnapGene!","BLOCK_QUOTE_FIRST_BLOCK_AUTHOR_5":"Scott","BLOCK_QUOTE_FIRST_BLOCK_INSTITUTION_5":"University of North Carolina, Chapel Hill","BLOCK_QUOTE_FIRST_BLOCK_DESCRIPTION_5":"This application blows everything else past and present out of the water. You all did an AMAZING job making SnapGene powerful and intuitive, yet simple. Excellent work.","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_1":"/images/snapgene/homepage/homepage-northwestern-university.png","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_1_ALT":"Northwestern University","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_2":"/images/snapgene/homepage/homepage-university-of-cambridge.png","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_2_ALT":"Gurdon Institute, University of Cambridge","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_3":"/images/snapgene/homepage/homepage-fred-hutchinson-cancer-center.png","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_3_ALT":"Fred Hutchinson Cancer Center","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_4":"/images/snapgene/homepage/homepage-emory-university.png","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_4_ALT":"Emory University","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_5":"/images/snapgene/homepage/homepage-university-of-north-carolina.png","BLOCK_QUOTE_SECOND_BLOCK_IMAGE_5_ALT":"University of North Carolina, Chapel Hill"}');

/***/ }),

/***/ 33686:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TRY_FREE_TEXT":"Discover the most <b>user-friendly</b> molecular biology experience.","TRY_FREE_BUTTON_TEXT":"Try for Free"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9146,5606,1989,2458,398,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);